module.exports = __webpack_public_path__ + "img/ico-man.3ddda8fd.svg";